<template>
  <div>
    <Breadcrumbs
      :paths="['/job', $route.path]"
    ></Breadcrumbs>
    <v-toolbar>
      <v-toolbar-title>
        {{ $t("message.job.job_detail") }}&nbsp;({{ $route.params.jid }})
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-icon v-on="on" class="ma-2" @click="get_detail_data(get_prefix() + 'job/', [$route.params.jid])">
            mdi-refresh
          </v-icon>
        </template>
        <span>{{ $t("message.common.refresh") }}</span>
      </v-tooltip>
    </v-toolbar>
    <v-card class="pa-5 mt-1" v-if="fetch_status === 'getting'">
      {{ $t("message.common.getting", { "id": $route.params.jid }) }}
      <p class="text-right">
        <v-btn :to="get_prev(get_prefix() + 'job')">
          {{ $t("message.common.prev") }}
        </v-btn>
      </p>
    </v-card>
    <v-card class="pa-5 mt-1" v-else-if="data">
      <v-simple-table>
        <template v-slot:default>
          <tbody>
            <tr>
              <td>
                {{ $i18n.t("message.common.jid") }}
              </td>
              <td>
                {{ data.jid }}
              </td>
            </tr>
            <tr>
              <td>
                {{ $i18n.t("message.common.title") }}
              </td>
              <td class="table-title">
                <v-card
                  class="d-flex justify-space-between"
                  flat
                >
                  <v-card flat class="align-self-center flex-grow-1">
                    <v-text-field
                      v-model="data.title"
                      :rules="[
                        v => (v && v.length <= 80) || $t('message.common.over_text', { length: 80 })
                      ]"
                      counter="80"
                    >
                    </v-text-field>
                  </v-card>
                  <template v-if="data.title !== original_data.title">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on" class="ma-2" @click="data.title = original_data.title">
                          mdi-undo-variant
                        </v-icon>
                      </template>
                      <span>{{ $t("message.common.undo") }}</span>
                    </v-tooltip>
                  </template>
                </v-card>
              </td>
            </tr>
            <tr>
              <td>
                {{ $i18n.t("message.job.job_type") }}
              </td>
              <td>
                {{ $i18n.t("message.job.job_type_" + data.type) }}
              </td>
            </tr>
            <tr>
              <td>
                {{ $i18n.t("message.job.parameter") }}
              </td>
              <td>
                <template v-if="data.parameters !== null">
                  <JobParameters
                    :mode="mode"
                    :type="data.type"
                    :parameters="data.parameters"
                    :nav_path="nav_path"
                  >
                  </JobParameters>
                </template>
                <template v-else>
                  -
                </template>
              </td>
            </tr>
            <tr>
              <td>
                {{ $i18n.t("message.common.status") }}
              </td>
              <td>
                <span :class="status_color[data.status]">{{ $t('message.job.status_' + data.status) }}</span>
              </td>
            </tr>
            <!--<tr>
              <td>
                {{ $i18n.t("message.common.progress") }}
              </td>
              <td class="pt-0 pb-0">
                <template v-if="['processing', 'finished'].indexOf(data.status) >= 0">
                  {{ Math.round(10 * data.progress) / 10 }}%
                  <v-progress-linear
                    :value="data.progress"
                  ></v-progress-linear>
                </template>
                <template v-else>
                  -
                </template>
              </td>
            </tr>
            <tr>
              <td>
                {{ $i18n.t("message.job.wait_time") }}
              </td>
              <td>
                <template v-if="data.status === 'processing'">
                  {{ show_second(data.wait_time) }}
                </template>
                <template v-else>
                  -
                </template>
              </td>
            </tr>-->
            <tr>
              <td>
                {{ $i18n.t("message.job.start_time") }}
              </td>
              <td>
                {{ $d(1000 * data.start_time, 'long', $store.getters.langs[$i18n.locale].locale) }}
              </td>
            </tr>
            <tr>
              <td>
                {{ $i18n.t("message.job.end_time") }}
              </td>
              <td>
                <template v-if="['cancelled', 'finished'].indexOf(data.status) >= 0">
                  {{ $d(1000 * data.end_time, 'long', $store.getters.langs[$i18n.locale].locale) }}
                </template>
                <template v-else>
                  -
                </template>
              </td>
            </tr>
            <tr>
              <td>
                {{ $i18n.t("message.job.expire_time") }}
              </td>
              <td>
                <template v-if="['processing'].indexOf(data.status) === -1">
                  {{ $d(1000 * data.expire_time, 'long', $store.getters.langs[$i18n.locale].locale) }}
                </template>
                <template v-else>
                  -
                </template>
              </td>
            </tr>
            <tr>
              <td>
                {{ $t("message.common.group") }}
              </td>
              <td>
                <IdName
                  :mode="mode"
                  type="group"
                  :ids="[data.gid]"
                  :nav_path="nav_path"
                ></IdName>
              </td>
            </tr>
            <tr>
              <td>
                {{ $t("message.common.user") }}
              </td>
              <td>
                <IdName
                  :mode="mode"
                  type="user"
                  :ids="[data.uid]"
                  :nav_path="nav_path"
                ></IdName>
              </td>
            </tr>
            <!--<tr>
              <td>
                {{ $i18n.t("message.job.result") }}
              </td>
              <td>
                {{ $i18n.t("message.job.result_" + data.result) }}
              </td>
            </tr>-->
            <tr>
              <td>
                {{ $i18n.t("message.job.error") }}
              </td>
              <td>
                <template v-if="data.error !== null">
                  {{ $t("error." + get_eid(data.error.eid), replace_param(data.error.eid, data.error.param)) }}&nbsp;({{ data.error.eid }})
                </template>
                <template v-else>
                  -
                </template>
              </td>
            </tr>
            <tr>
              <td>
                {{ $i18n.t("message.job.input") }}
              </td>
              <td class="pt-0 pb-0">
                <template v-if="data.input !== null && Object.keys(data.input).length > 0">
                  <template v-for="(inputs, key) in data.input">
                    <v-subheader :key="key" class="pl-0">
                      {{ $i18n.t("message.common." + key) }}
                    </v-subheader>
                    <v-list v-for="input in inputs.id" :key="input">
                      <v-list-item dense class="pa-0">
                        <IdName
                          :mode="mode"
                          :type="inputs.type"
                          :ids="[input]"
                          :nav_path="nav_path"
                        ></IdName>
                      </v-list-item>
                    </v-list>
                  </template>
                </template>
                <template v-else>
                  -
                </template>
              </td>
            </tr>
            <tr>
              <td>
                {{ $i18n.t("message.job.output") }}
              </td>
              <td class="pt-0 pb-0">
                <template v-if="data.output">
                  <v-list>
                    <v-list-item dense class="pa-0">
                      <IdName
                        :mode="mode"
                        :type="data.output.type"
                        :ids="[data.output.id]"
                        :nav_path="nav_path"
                        :remarks="['estimate', 'similarity'].indexOf(data.type) >= 0 ? [data.type] : null"
                      ></IdName>
                    </v-list-item>
                  </v-list>
                </template>
                <template v-else>
                  -
                </template>
              </td>
            </tr>
            <tr>
              <td>
                {{ $i18n.t("message.common.operation") }}
              </td>
              <td>
                <div class="buttonContents">
                  <template v-if="['finished', 'cancelled', 'failed'].indexOf(data.status) >= 0 && deletable()">
                    <v-btn
                      @click="confirm_delete_data(get_prefix() + 'job', [data.jid])"
                    >
                      {{ $t("message.common.delete") }}
                    </v-btn>
                  </template>
                </div>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <p class="text-right">
        <!--<template v-if="data.status === 'processing'">
          <v-btn
            @click=""
          >
            {{ $t("message.common.cancel") }}
          </v-btn>
        </template>-->
        <template v-if="changeable()">
          <v-btn
            color="primary"
            :disabled="!modifiable"
            @click="change_data('job', [data.jid])"
          >
            {{ $t("message.common.modify") }}
          </v-btn>
        </template>
        <v-btn :to="get_prev(get_prefix() + 'job')">
          {{ $t("message.common.prev") }}
        </v-btn>
      </p>
    </v-card>
    <v-card class="pa-5 mt-1" v-else>
      {{ $t("message.common.no_id", { "id": $route.params.jid }) }}
      <p class="text-right">
        <v-btn :to="get_prev(get_prefix() + 'job')">
          {{ $t("message.common.prev") }}
        </v-btn>
      </p>
    </v-card>
    <Confirm
      ref="delete_confirm"
      :message="$t('message.common.delete_confirm')"
      :positive="$t('message.common.yes')"
      :negative="$t('message.common.no')"
    >
    </Confirm>
  </div>
</template>

<script>
import Breadcrumbs from '../components/Breadcrumbs';
import IdName from '../components/IdName';
import Confirm from '../components/Confirm';
import JobParameters from '../components/JobParameters';
import { res_detail } from "../js/res_detail";
import { get_eid } from "../js/get_eid";
import { http_error } from "../js/http_error";

export default {
  name: 'job_detail',
  components: {
    Breadcrumbs,
    IdName,
    Confirm,
    JobParameters
  },
  mixins: [res_detail, get_eid, http_error],
  props: {
    mode: String
  },
  data: function(){
    return {
      module_id: "26",
      nav_path: null,
      fetch_status: "getting",
      data: null,
      original_data: null,
      editable: {
        title: () => (this.data && this.data.title.length > 0 && this.data.title.length <= 80)
      },
      job_types: [
        {
          "label": "translate",
          "value": "translate"
        },
        {
          "label": "estimate",
          "value": "estimate"
        },
        {
          "label": "train",
          "value": "train"
        },
        {
          "label": "corpus_import",
          "value": "corpus_import"
        },
        {
          "label": "similarity",
          "value": "similarity"
        }
      ],
      status_color: {
        "pending": "",
        "finished": "lime--text",
        "processing": "",
        "failed": "red--text",
        "cancelled": "grey--text"
      }
    }
  },
  mounted: function(){
    this.get_detail_data(this.get_prefix() + 'job/', [this.$route.params.jid]);
  },
  methods: {
    show_second: function(second){
      var hour = Math.floor(second / 3600);
      var minute = Math.floor((second % 3600) / 60);
      if(hour > 0){
        return hour + ":" + ('0' + minute).slice(-2) + ":" + ('0' + (second % 60)).slice(-2);
      }
      return ('0' + minute).slice(-2) + ":" + ('0' + (second % 60)).slice(-2)
    },
    replace_param: function(eid, param){
      if(["217", "218", "253", "254"].indexOf(eid.split(":")[0].slice(-3)) >= 0){
        return {
          layer: this.$i18n.t("message.limit_usage.layer_" + param.layer),
          resource: this.$i18n.t("message.limit_usage.resource_" + param.resource)
        }
      }else{
        return param;
      }
    }
  }
}
</script>

<style scoped>
.v-data-table
  tbody
  tr:hover:not(.v-data-table__expanded__content) {
  background: inherit !important;
}
.v-data-table td:first-of-type {
  white-space : nowrap;
}
.v-data-table {
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  margin-bottom: 12px;
}
.v-data-table
  tbody > tr > td:first-of-type {
  background-color: #eeeeee;
}
.table-title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 0;
}
</style>
